// @flow
import WizzeeLog from '../../lib/wizzeeLog';

export const initialState: VoucherStateType = {
  availabeVouchers: [],
  currentVoucherDetails: null,
  comeFrom: '',
};

export const voucherReducer = (
  state: VoucherStateType = initialState,
  action: VoucherActionType,
) => {
  switch (action.type) {
    case 'FETCH_AVAILABLE_VOUCHERS_SUCCESS':
      const availabeVouchers = action.availabeVouchers;

      return {
        ...state,
        availabeVouchers,
      };

    case 'SET_CURRENT_VOUCHER_DETAILS':
      WizzeeLog.log(
        '>>>> voucherReducer - [SET_CURRENT_VOUCHER_DETAILS] action',
        action,
      );
      const currentVoucherDetails = action.currentVoucherDetails;

      return {
        ...state,
        currentVoucherDetails,
      };

    case 'SET_VOUCHER_DETAILS_COME_FROM':
      const comeFrom = action.comeFrom?.toLowerCase();

      return {
        ...state,
        comeFrom,
      };
    default:
      return state;
  }
};

export type VoucherStateType = {|
  availabeVouchers: Object[],
  currentVoucherDetails: Object,
  comeFrom: string,
|};
